import _ from 'underscore';
import getStateDateRange from './util/get-state-date-range';
import getStateComparedDateRange from './util/get-state-compared-date-range';
import { getSelectionDateFormatter } from './util/selection-date';

export default function lockDownSelectionDateRange({
  Selection,
  today,
  i18n,
}) {
  const {
    DateRange,
    ComparisonDateRange,
  } = Selection;

  const primaryDateRange = getStateDateRange({
    today,
    i18n,
    DateRange,
  });

  const comparedDateRange = getStateComparedDateRange({
    today,
    i18n,
    primaryRange: primaryDateRange,
    ComparisonDateRange,
  });

  const selectionDateFormatter = getSelectionDateFormatter(i18n);

  return _.defaults({
    DateRange: {
      StartDate: selectionDateFormatter(primaryDateRange.start),
      EndDate: selectionDateFormatter(primaryDateRange.end),
    },
    ComparisonDateRange: comparedDateRange ? {
      StartDate: selectionDateFormatter(comparedDateRange.start),
      EndDate: selectionDateFormatter(comparedDateRange.end),
    } : null,
  }, Selection);
}
